import { AccountsView } from "./_components";

export default function AccountsPage() {
  return <AccountsView />;
}
